/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function SortDescending(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M231.39062,91.04724A7.99937,7.99937,0,0,1,224,95.9867l-32,.00268v48.00415a8,8,0,0,1-16,0V95.99085l-31.999.00268a8.00037,8.00037,0,0,1-5.65772-13.65723l40-40a8.00122,8.00122,0,0,1,11.313,0l39.999,39.99317A8.00019,8.00019,0,0,1,231.39062,91.04724ZM48,135.99353h71.999a8,8,0,1,0,0-16H48a8,8,0,0,0,0,16Zm0-64h55.999a8,8,0,0,0,0-16H48a8,8,0,1,0,0,16Zm135.999,112H48a8,8,0,0,0,0,16H183.999a8,8,0,0,0,0-16Z" />
    </Svg>
  );
}

export default SortDescending;
